import { PayloadAction } from "@reduxjs/toolkit";
import { channelsApi } from "api/ChannelsApi";
import { ChannelsTypeList, CreatePartner } from "models/Channels";
import { toast } from "react-toastify";
import { call, put } from "redux-saga/effects";
import { getSupervisorsOrPartnersList } from "redux/channels/channelsActions";
import { setChannelsLoading } from "redux/channels/channelsSlice";
import { parseError } from "shared/src/helpers/errorHandler";

export function* createPartnerSaga(action: PayloadAction<CreatePartner>) {
  try {
    yield put(setChannelsLoading(true));
    yield call([channelsApi, channelsApi.createPartner], action.payload);
    yield put(getSupervisorsOrPartnersList({ type: ChannelsTypeList.partner }));
  } catch (e) {
    yield call([toast, toast.error], parseError(e)?.message);
    console.error(e);
  }
}
